import { Box, styled } from '@mui/material';

const Wrapper = styled(Box)`
  display: flex;
  flex-direction: column;
  align-items: center;

  gap: 1rem;

  margin-top: 120px;
`;

export default Wrapper;
